var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFooterWave32X20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "#fff",
    fillRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.473 14.93c4.878-5.239 7.384 3.261 14.247 1.899-5.31 6.217-9.666-2.662-14.247-1.899zM15.32 3.724c4.877-5.239 7.384 3.261 14.247 1.9-5.311 6.217-9.666-2.662-14.247-1.9zM1 7.433c7.082-12.649 17.165 10.248 29.729 2.733C22.884 24.85 6.674 2.598 1 7.433z"
  })));
}

export default SvgFooterWave32X20;